const levenshteinDistance = (a, b) => {
  const matrix = Array.from({ length: a.length + 1 }, (_, i) => Array(b.length + 1).fill(i));
  for (let j = 1; j <= b.length; j += 1) matrix[0][j] = j;

  for (let i = 1; i <= a.length; i += 1) {
    for (let j = 1; j <= b.length; j += 1) {
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1,
        matrix[i][j - 1] + 1,
        matrix[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1),
      );
    }
  }

  return matrix[a.length][b.length];
};

const compareStrings = (str1, str2, threshold = 0.65) => {
  const clean1 = str1.trim().toLowerCase();
  const clean2 = str2.trim().toLowerCase();
  const maxLen = Math.max(clean1.length, clean2.length);
  const distance = levenshteinDistance(clean1, clean2);
  const similarity = 1 - (distance / maxLen);

  return {
    similarity,
    isSimilar: similarity >= threshold,
  };
};

export default compareStrings;
